import axios from 'axios';
import Qs from 'qs';
import {getCookie} from 'utils/functions/cookies';
import {AxiosAuthRefreshRequestConfig} from 'axios-auth-refresh';

// declares the axios instance to be used for flagrAPI communication
const flagrAPIClient = axios.create({
  timeout: 360 * 1000,
  baseURL: 'https://flags.letrus.com.br',
  paramsSerializer: queryParamsSerializer,
});

// filters null and repeated values from the query params and keep them on the right format
function queryParamsSerializer(params: Record<string, unknown>) {
  return Qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true});
}

// returns a configured axios instance,  bearing the correct auth token
function flagrAPI(url: string, axiosParams?: AxiosAuthRefreshRequestConfig) {
  const customHeaders = {
    ...axiosParams?.headers,
    'x-csrftoken': getCookie('csrftoken'),
    'Content-Type': 'application/json',
  };

  return flagrAPIClient({
    url,
    headers: customHeaders,
    withCredentials: true,
    ...axiosParams,
  });
}

export default flagrAPI;
